module.exports = __webpack_public_path__ + "img/logo-compact.91994951.svg";